import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { ClientPod, ReservationRequiredField } from '../generated/graphql';

export type RequiredFieldOption = {
  value: ReservationRequiredField;
  label: string;
  readOnly?: boolean;
  scope?: string; // Will be 'ORDER' | 'GUEST' | 'ASSIGNMENT' when provided by backend
};

export interface ClientConfigState {
  pod?: ClientPod;
  requiredFields: RequiredFieldOption[];
}

const initialState: ClientConfigState = {
  pod: undefined,
  requiredFields: [],
};

export const clientConfigSlice = createSlice({
  name: 'clientConfig',
  initialState,
  reducers: {
    setClientConfig: (state, { payload }: PayloadAction<ClientConfigState>) => {
      return {
        ...state,
        ...payload,
      };
    },
  },
});

export const { setClientConfig } = clientConfigSlice.actions;

export const clientConfigReducer = clientConfigSlice.reducer;
